<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" md="3" v-for="(stat, i) in summaryStats" :key="i">
          <v-card
            class="rounded-lg shadow-sm border-left-lg"
            :style="{ borderLeftColor: stat.color }"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-2 grey--text">{{ stat.title }}</div>
                <v-list-item-title
                  class="headline mb-1 font-weight-bold"
                  :class="stat.color + '--text'"
                >
                  {{ stat.value }}
                  <small class="caption grey--text">{{ stat.unit }}</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" :color="stat.color + ' lighten-5'">
                <v-icon :color="stat.color" large>{{ stat.icon }}</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="จัดการข้อมูลเงื่อนไขการรับย้ายสาขาวิชา"
        color="success"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn
                small
                rounded
                color="primary"
                dark
                :href="reportLinks.conditionAll"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> รายงานเงื่อนไข (ตามรอบ)
              </v-btn>
              <v-btn
                small
                rounded
                color="info"
                dark
                href="#/admin/print_jor18_teacherMove/"
                target="_blank"
              >
                <v-icon left>mdi-printer-settings</v-icon> รายงานเงื่อนไขทั้งหมด
              </v-btn>
              <v-btn small rounded color="success" @click="AddConditionBranch">
                <v-icon left>mdi-plus-circle</v-icon> เพิ่มสาขากรณีพิเศษ
              </v-btn>
              <v-btn
                small
                rounded
                outlined
                color="green darken-2"
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="collegeSearch"
                :items="collegesec"
                item-text="college_name"
                item-value="college_code"
                label="ค้นหาและพิมพ์รายวิทยาลัย"
                prepend-inner-icon="mdi-school"
                dense
                outlined
                hide-details
                rounded
                class="bg-white"
              >
                <template v-slot:append-outer>
                  <v-btn
                    v-if="collegeSearch"
                    icon
                    color="info"
                    :href="reportLinks.collegeCondition"
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหาข้อมูล (ระบุคำค้นหา)"
          outlined
          dense
          rounded
          class="mb-2"
          hide-details
        ></v-text-field>

        <v-data-table
          :headers="headers"
          :items="conditions_transfers"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
        >

        <template v-slot:item.name_branch="{ item }">
         {{ item.id_branch }} : {{ item.name_branch }}
        </template>

   
          <template v-slot:item.status_confirm="{ item }">
            <v-chip
              :color="getStatusColor(item.status_confirm)"
              dark
              small
              class="font-weight-bold"
            >
              {{ getStatusText(item.status_confirm) }}
            </v-chip>
          </template>

          <template v-slot:item.Order_file="{ item }">
            <div class="d-flex align-center justify-center">
              <v-tooltip bottom v-if="item.Order_file">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="blue"
                    :href="'/HRvecfiles/' + item.Order_file"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-document-outline</v-icon>
                  </v-btn>
                </template>
                <span>ดูไฟล์แนบ</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    @click="deleteRecord(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบข้อมูล</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.con_datail_branch="{ item }">
            <v-chip
              v-if="item.con_datail_branch"
              color="teal lighten-5"
              text-color="teal darken-2"
              small
              label
              @click="detail_select(item.id_cb)"
              style="cursor: pointer"
            >
              <v-icon left x-small>mdi-pencil</v-icon>
              {{ item.con_datail_branch }} : {{ item.conditions_branch_comment }}
            </v-chip>
            <v-btn
              v-else
              icon
              small
              color="grey"
              @click="detail_select(item.id_cb)"
            >
              <v-icon>mdi-pencil-plus</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selectedItems"
              :value="item.college_code"
              hide-details
              class="mt-0"
            ></v-checkbox>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog
        v-model="adconditions_branchdialog"
        persistent
        max-width="700px"
      >
        <v-card class="rounded-xl">
          <v-toolbar flat color="success" dark>
            <v-icon left>mdi-plus-box</v-icon>
            <v-toolbar-title
              >เพิ่มข้อมูลเงื่อนไขสาขาวิชา (กรณีพิเศษ)</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="adconditions_branchdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pa-6">
            <v-form ref="adconditions_branchform" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="adconditions_branch.college_code"
                    :items="colleges"
                    item-text="college_name"
                    item-value="college_code"
                    label="สถานศึกษา"
                    prepend-inner-icon="mdi-school"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="adconditions_branch.id_branch"
                    :items="branch_s"
                    item-text="name_branch"
                    item-value="id_branch"
                    label="สาขาวิชาเอก"
                    prepend-inner-icon="mdi-book-open-variant"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'กรุณาเลือกสาขา']"
                    @change="branch_sub_dQueryAll()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="adconditions_branch.con_id_branch_sub"
                    :items="branch_sub_ds"
                    item-text="name_sub_branch"
                    item-value="id_branch_sub"
                    label="สาขางานย่อย"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'กรุณาเลือกสาขางาน']"
                    :disabled="!adconditions_branch.id_branch"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    label="จำนวนรับ (คน)"
                    v-model="adconditions_branch.quantity_n"
                    prepend-inner-icon="mdi-account-plus"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'ระบุจำนวน']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="education_s"
                    item-text="title"
                    item-value="title"
                    label="ระดับการศึกษา"
                    v-model="adconditions_branch.educational_level"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'เลือกระดับการศึกษา']"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="รายละเอียดคุณลักษณะ (เพิ่มเติม)"
                    v-model="adconditions_branch.con_datail_branch"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'ระบุรายละเอียด']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="Order_file"
                    accept=".pdf"
                    label="แนบไฟล์คำสั่ง/เอกสาร (.pdf)"
                    prepend-icon="mdi-paperclip"
                    outlined
                    rounded
                    dense
                    :rules="rules"
                    show-size
                    small-chips
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-divider class="mb-4"></v-divider>
                  <div class="subtitle-2 error--text mb-2">
                    * ระบบความปลอดภัย
                  </div>
                  <v-text-field
                    label="รหัสผ่านยืนยัน (Admin Password)"
                    v-model="adconditions_branch.secret"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    outlined
                    rounded
                    dense
                    @click:append="show1 = !show1"
                    required
                    :rules="[v => v == '0612698358' || 'รหัสผ่านไม่ถูกต้อง']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4 grey lighten-5">
            <v-btn text @click="adconditions_branchdialog = false" rounded
              >ยกเลิก</v-btn
            >
            <v-btn
              color="success"
              @click="adconditions_branchSubmit"
              rounded
              class="px-6"
            >
              <v-icon left>mdi-content-save</v-icon> บันทึกข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteconditions_branchdialog"
        persistent
        max-width="450px"
      >
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
            ยืนยันการลบ
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1 mb-2">
              คุณต้องการลบเงื่อนไขนี้ใช่หรือไม่?
            </div>
            <v-alert dense outlined color="grey darken-1" class="caption">
              {{ editconditions_branch.college_name }} <br />
              สาขา: {{ editconditions_branch.name_branch }} <br />
              ระดับ: {{ editconditions_branch.educational_level }}
            </v-alert>
            <v-form ref="deleteconditions_branchform" lazy-validation>
              <v-text-field
                label="รหัสผ่านยืนยัน (Admin Password)"
                v-model="adconditions_branch.secret"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                outlined
                dense
                rounded
                @click:append="show1 = !show1"
                required
                :rules="[v => v == '0612698358' || 'รหัสผ่านไม่ถูกต้อง']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteconditions_branchdialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="error"
              depressed
              @click="deleteconditions_branchSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="update_detailsdialog" persistent max-width="500px">
        <v-card class="rounded-lg">
          <v-card-title class="primary--text"
            >แก้ไขรายละเอียดเพิ่มเติม</v-card-title
          >
          <v-card-text class="pt-4">
            <v-form ref="addconditions_branchform">
              <v-textarea
                v-model="conditions_branchs.con_datail_branch"
                label="รายละเอียดสาขาวิชา"
                outlined
                rows="3"
                auto-grow
              ></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="update_detailsdialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" depressed @click="adddetail_conditionsSubmit"
              >บันทึก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องรัน npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      show1: false,
      search: "",
      collegeSearch: "",
      selectedItems: [],

      // Dialogs
      adconditions_branchdialog: false,
      deleteconditions_branchdialog: false,
      update_detailsdialog: false,

      // Data Models
      conditions_transfers: [],
      period_colleges: {},
      adconditions_branch: {},
      editconditions_branch: {},
      conditions_branchs: {},
      update_details: {},

      // Lists
      colleges: [],
      collegesec: [],
      branch_s: [],
      branch_sub_ds: [],
      education_s: [
        { title: "ปริญญาตรี" },
        { title: "ปริญญาโท" },
        { title: "ปริญญาเอก" }
      ],

      // File Input
      Order_file: null,
      rules: [v => !v || v.size < 1048576 || "ไฟล์ต้องไม่เกิน 1 MB"],

      // UI Config
      snackbar: { show: false, color: "", icon: "", text: "" },
      headers: [
        {
          text: "เลือก",
          align: "center",
          value: "select_item",
          sortable: false
        },
        { text: "สถานะ", align: "center", value: "status_confirm" },
        { text: "รหัส", align: "center", value: "college_code" },
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        { text: "รายละเอียด", align: "left", value: "con_datail_branch" },
        { text: "วุฒิ", align: "center", value: "educational_level" },
        { text: "รับ (คน)", align: "center", value: "quantity_n" },
        {
          text: "จัดการ",
          align: "center",
          value: "Order_file",
          sortable: false
        }
      ]
    };
  },

  computed: {
    summaryStats() {
      const total = this.conditions_transfers.length;
      const receive = this.conditions_transfers.filter(
        i => i.status_confirm === "receive"
      ).length;
      const needless = this.conditions_transfers.filter(
        i => i.status_confirm === "needless"
      ).length;
      return [
        {
          title: "เงื่อนไขทั้งหมด",
          value: total,
          unit: "รายการ",
          icon: "mdi-clipboard-list",
          color: "blue"
        },
        {
          title: "เสนอรับย้าย",
          value: receive,
          unit: "รายการ",
          icon: "mdi-check-circle",
          color: "success"
        },
        {
          title: "ไม่ประสงค์รับ",
          value: needless,
          unit: "รายการ",
          icon: "mdi-close-circle",
          color: "orange"
        },
        {
          title: "รอการบันทึก",
          value: total - receive - needless,
          unit: "รายการ",
          icon: "mdi-clock",
          color: "grey"
        }
      ];
    },
    reportLinks() {
      const {
        period_college_times,
        period_college_year
      } = this.period_colleges;
      return {
        conditionAll: `#/admin/print_report_condition_all/${period_college_times}/${period_college_year}`,
        collegeCondition: `#/college/print_condition/?id_ref=${period_college_times}${period_college_year}${this.collegeSearch}`
      };
    }
  },

  async mounted() {
    await this.period_collegeQuery();
    await this.conditions_transferQueryAll();
    await this.collegeQueryAll();
  },

  methods: {
    // --- Data Fetching ---
    async period_collegeQuery() {
      let res = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "401"
      });
      this.period_colleges = res.data;
    },
    async conditions_transferQueryAll() {
      this.loading = true;
      let res = await this.$http
        .post("conditions_transfer.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = res.data;
    },
    async collegeQueryAll() {
      let res = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.collegesec = res.data;
    },

    // --- Actions ---
    async AddConditionBranch() {
      this.adconditions_branchdialog = true;
      this.adconditions_branch = {};
      let res1 = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.colleges = res1.data;
      let res2 = await this.$http.post("branch.php", { ApiKey: this.ApiKey });
      this.branch_s = res2.data;
    },

    async branch_sub_dQueryAll() {
      if (!this.adconditions_branch.id_branch) return;
      let res = await this.$http.post("branch_sub_d.php", {
        ApiKey: this.ApiKey,
        id_main_branch: this.adconditions_branch.id_branch
      });
      this.branch_sub_ds = res.data;
    },

    async adconditions_branchSubmit() {
      if (this.$refs.adconditions_branchform.validate()) {
        this.loading = true;

        // Prepare ID Ref
        this.adconditions_branch.id_ref =
          this.period_colleges.period_college_times +
          this.period_colleges.period_college_year +
          this.adconditions_branch.college_code;
        this.adconditions_branch.ApiKey = this.ApiKey;
        this.adconditions_branch.condStatus = "save";

        // File Upload Logic
        if (this.Order_file) {
          let formData = new FormData();
          let filename = `${
            this.adconditions_branch.college_code
          }${Date.now()}CBEdit.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.Order_file);
          formData.append("filename", "../HRvecfiles/" + filename);

          let uploadRes = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          if (uploadRes.data.status)
            this.adconditions_branch.Order_file = filename;
        }

        // Insert Logic
        let res = await this.$http.post(
          "conditions_branch.insert.php",
          this.adconditions_branch
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success");
          this.adconditions_branchdialog = false;
          await this.conditions_transferQueryAll();
        } else {
          this.showSnackbar(res.data.message || "บันทึกข้อมูลล้มเหลว", "error");
        }
        this.loading = false;
      }
    },

    // --- Delete Logic ---
    deleteRecord(item) {
      // Map item fields to editconditions_branch for display and deletion
      this.editconditions_branch = {
        ...item,
        con_id_branch_sub: item.con_id_branch_sub,
        educational_level: item.educational_level
      };
      this.adconditions_branch = { secret: "" }; // Reset password field
      this.deleteconditions_branchdialog = true;
    },

    async deleteconditions_branchSubmit() {
      if (this.$refs.deleteconditions_branchform.validate()) {
        let payload = {
          ApiKey: this.ApiKey,
          id_ref: this.editconditions_branch.id_ref,
          id_branch: this.editconditions_branch.id_branch,
          con_id_branch_sub: this.editconditions_branch.con_id_branch_sub,
          educational_level: this.editconditions_branch.educational_level
        };

        // Delete File if exists
        if (this.editconditions_branch.Order_file) {
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename: "../HRvecfiles/" + this.editconditions_branch.Order_file
          });
        }

        let res = await this.$http.post(
          "conditions_branch.delete.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("ลบข้อมูลเรียบร้อย", "success");
          this.deleteconditions_branchdialog = false;
          await this.conditions_transferQueryAll();
        } else {
          this.showSnackbar("เกิดข้อผิดพลาดในการลบ", "error");
        }
      }
    },

    // --- Detail Update Logic ---
    async detail_select(id_cb) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_cb: id_cb
      });
      this.conditions_branchs = res.data;
      this.update_detailsdialog = true;
    },

    async adddetail_conditionsSubmit() {
      this.update_details = {
        ApiKey: this.ApiKey,
        id_cb: this.conditions_branchs.id_cb,
        con_datail_branch: this.conditions_branchs.con_datail_branch
      };

      let res = await this.$http.post(
        "conditions_branch.update.php",
        this.update_details
      );
      if (res.data.status) {
        this.showSnackbar("อัปเดตรายละเอียดเรียบร้อย", "success");
        this.update_detailsdialog = false;
        await this.conditions_transferQueryAll();
      } else {
        this.showSnackbar("อัปเดตล้มเหลว", "error");
      }
    },

    // --- Helpers ---
    exportToExcel() {
      let data = this.conditions_transfers.map(item => ({
        สถานะ: this.getStatusText(item.status_confirm),
        รหัสสถานศึกษา: item.college_code,
        ชื่อสถานศึกษา: item.college_name,
        สาขาวิชา: item.name_branch,
        รายละเอียด: item.con_datail_branch,
        วุฒิการศึกษา: item.educational_level,
        จำนวนรับ: item.quantity_n
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Conditions");
      XLSX.writeFile(wb, `Conditions_Branch_${Date.now()}.xlsx`);
    },

    getStatusColor(status) {
      if (status === "receive") return "primary";
      if (status === "needless") return "warning";
      return "grey";
    },

    getStatusText(status) {
      if (status === "receive") return "เสนอรับ";
      if (status === "needless") return "ไม่ประสงค์รับ";
      return "รอการบันทึก";
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f5f5f5;
}
.shadow-sm {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05) !important;
}
.border-left-lg {
  border-left: 5px solid;
}
</style>
